module.exports = __webpack_public_path__ + "img/admin_apk.png";